import React, { FC } from 'react';
import './FormButtons.scss';
import AppButton from '../../../../../components/ui/components/Buttons/AppButton/AppButton';
import { useTranslation } from "react-i18next";

interface Props {
   onCancel: (e: HTMLButtonElement) => void;
   isSending: boolean;
   onSave: () => void;
}

const FormButtons: FC<Props> = (props) => {
   const {onCancel, isSending, onSave} = props;
   const [t] = useTranslation();

   return (
      <div className="form-buttons">
         <AppButton theme="light" size="middle" onClick={onCancel}>
           {t("Скасувати")}
         </AppButton>
         <AppButton size="middle" showIndicator={isSending} onClick={onSave} >
           {t("Зберегти")}
         </AppButton>
      </div>
   );
};

export default FormButtons;